import { render, staticRenderFns } from "./LogisticsData.vue?vue&type=template&id=3e99e7cd&"
import script from "./LogisticsData.vue?vue&type=script&lang=js&"
export * from "./LogisticsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports